<template>
  <div id="profit">
    <el-select v-model="paras.status" placeholder="请选择" @change="handleSearch">
      <el-option v-for="n in travelStatus" :key="n.key" :label="n.label" :value="n.value"></el-option>
    </el-select>
    <!-- 开票列表 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="订单号" prop="orderSn"></el-table-column>
      <el-table-column label="申请时间">
        <template slot-scope="scope">{{ scope.row.createTime | formatTimer }}</template>
      </el-table-column>
      <el-table-column label="买家名称" prop="memberUsername"></el-table-column>
      <el-table-column label="产品名称" prop="productName"></el-table-column>
      <el-table-column label="产品价格" prop="productPrice"></el-table-column>
      <el-table-column label="退款金额" prop="returnAmount"></el-table-column>
      <el-table-column label="支付方式" prop="payType">
        <template
          slot-scope="scope"
        >{{ scope.row.payType===1?'支付宝':(scope.row.payType===2?'微信':'') }}</template>
      </el-table-column>
      <el-table-column label="退款类型" prop="type">
        <template slot-scope="scope">{{ scope.row.type===1?'仅退款':'退款退货' }}</template>
      </el-table-column>
      <el-table-column label="退款原因" prop="reason"></el-table-column>
      <el-table-column label="退款描述" prop="description"></el-table-column>
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleDetail(scope.$index, scope.row)">查看</el-button>
          <el-button
            v-if="scope.row.status===0"
            size="mini"
            type="success"
            @click="handleSendAg(scope.$index, scope.row)"
          >同意</el-button>
          <el-button
            v-if="scope.row.status===0"
            size="mini"
            type="warning"
            @click="handleSendRe(scope.$index, scope.row)"
          >拒绝</el-button>
          <el-button
            v-if="scope.row.status===1"
            size="mini"
            type="danger"
            @click="handleTui(scope.$index, scope.row)"
          >退款</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 同意退款 -->
    <div>
      <el-dialog title="请认真核对订单之后再确认退款" :visible.sync="sendGoodsdialogVisible" width="50%">
        <!-- 发货需要的数据 -->
        <el-form :model="ruleForm" ref="ruleForm" label-width="190px">
          <el-form-item label="处理备注" prop="handleNote">
            <el-input v-model="ruleForm.handleNote"></el-input>
          </el-form-item>
          <el-form-item v-if="this.ruleForm.type===2" label="退货地址" prop="companyAddressId">
            <!-- <el-select v-model="ruleForm.companyAddressId" placeholder="请选择退货地址">
              <el-option label="上海市普陀区" value="1"></el-option>
            </el-select>-->
            <!-- 分页的下拉 -->
            <el-select v-loadMore="loadMore" v-model="ruleForm.companyAddressId" placeholder="请选择">
              <el-option
                v-for="item in selectSysInstanceList"
                :label="item.addressName"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="sendGoodsdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSendExpress">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 拒绝退款 -->
    <div>
      <el-dialog title="请确认信息后再拒绝退款" :visible.sync="sendGoodsdialogVisible2" width="50%">
        <!-- 发货需要的数据 -->
        <el-form :model="ruleFormCr" ref="ruleFormCr" label-width="190px">
          <el-form-item label="拒绝原因" prop="handleNote">
            <el-input v-model="ruleFormCr.handleNote"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="sendGoodsdialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="handleRe">拒绝退款</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 正式退款 -->
    <div>
      <el-dialog title="确认退款" :visible.sync="sendGoodsdialogVisible3" width="30%">
        <span style="font-size:18px;color:red">请谨慎操作，一旦退款将无法返回</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="sendGoodsdialogVisible3 = false">取 消</el-button>
          <el-button type="danger" @click="handleTuiKuan">退 款</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 查看订单dialog -->
    <div>
      <el-dialog title="退款详情" :visible.sync="detaildialogVisible" width="30%">
        <el-descriptions class="margin-top" title :column="1" border>
          <el-descriptions-item>
            <template slot="label">订单号</template>
            {{detailData.orderSn}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">申请时间</template>
            {{ detailData.createTime | formatTimer }}
          </el-descriptions-item>
          <el-descriptions-item v-if="detailData.memberUsername">
            <template slot="label">买家名称</template>
            {{detailData.memberUsername}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">产品名称</template>
            {{detailData.productName}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">型号</template>
            {{detailData.productAttr}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">数量</template>
            {{detailData.productCount}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">退款金额</template>
            {{detailData.returnAmount}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">退款类型/原因</template>
            {{detailData.reason}}
          </el-descriptions-item>
          <el-descriptions-item v-if="detailData.description">
            <template slot="label">退款描述</template>
            {{detailData.description}}
          </el-descriptions-item>
          <el-descriptions-item v-if="url">
            <template slot="label">退款拍照</template>
            <div class="demo-image__preview">
              <el-image
                style="width: 150px; height: 150px"
                ref="preview"
                :src="url"
                :preview-src-list="srcList"
                @click="onPreview"
              ></el-image>
            </div>
          </el-descriptions-item>
          <el-descriptions-item v-if="detailData.handleNote">
            <template slot="label">处理备注</template>
            {{detailData.handleNote}}
          </el-descriptions-item>
          <el-descriptions-item v-if="detailData.companyAddress">
            <template slot="label">退货地址信息</template>
            {{detailData.companyAddress}}
          </el-descriptions-item>
          <el-descriptions-item v-if="detailData.expressName">
            <template slot="label">物流公司</template>
            {{detailData.expressName}}
          </el-descriptions-item>
          <el-descriptions-item v-if="detailData.expressSn">
            <template slot="label">物流单号</template>
            {{detailData.expressSn}}
          </el-descriptions-item>
          <el-descriptions-item v-if="detailData.expressSn" >
            <template slot="label">物流信息</template>
            <div>
              <el-steps direction="vertical" :active="1">
                <el-step
                  v-for="n in wuliuArr"
                  :key="n.key"
                  :title="n.context"
                  :description="n.time"
                ></el-step>
              </el-steps>
            </div>
          </el-descriptions-item>
        </el-descriptions>
        <span slot="footer" class="dialog-footer">
          <el-button @click="detaildialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="detaildialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 分页 -->
    <div style="margin-top:30px ;text-align:center; ">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="handelCurrentChange"
        :current-page="currentpageIndex"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { queryByReturnOrderList, updateReturnOrderHandle, returnMoney, queryListAddress,queryOrderDetails,queryWuLiu } from '../../api'
export default {
  // 自定义创建指令
  directives: {
    loadMore: {
      bind (el, binding) {
        console.log(el, binding);
        // 获取element，定义scroll
        let select_dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        select_dom.addEventListener('scroll', function () {
          let height = this.scrollHeight - this.scrollTop <= this.clientHeight;
          console.log(this.scrollHeight);
          console.log(this.scrollTop);
          console.log(this.clientHeight);
          console.log(height);
          if (height) {
            binding.value()
          }
        })
      }
    }
  },

  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      // 退款
      ruleFormTui: {
        id: '',
      },
      // 拒绝
      ruleFormCr: {
        id: '',
        handleNote: ''
      },
      status: 0,
      paras: {
        status: 0,
      },
      travelStatus: [ //  状态列表
        {
          value: 0,
          label: '待处理'
        },
        {
          value: 1,
          label: '退款中'
        },
        {
          value: 2,
          label: '已完成'
        },
        {
          value: 3,
          label: '已拒绝'
        }
      ],
      // 订单详情dialog
      detaildialogVisible: false,
      detailData: [],
      ruleForm: {
        type: '',
        id: '',
        handleNote: '',
        companyAddressId: '',
      },
      sysInstanceIndex: 1,
      selectSysInstanceList: [],
      sysInstanceTotalPages: 0,
      tableData: [],
      total: 0,
      currentpageIndex: 1,
      currentpageSize: 10,
      //开票弹窗
      sendGoodsdialogVisible: false,
      sendGoodsdialogVisible2: false,
      sendGoodsdialogVisible3: false,
      url: '',
      srcList: [],
      // 物流数据
      wuliuArr: []
    }
  },
  filters: {
    formatTimer: function (value) {
      if (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      } else {
        return "/"
      }

    }
  },
  //进入页面之前请求数据
  mounted () {
    this.getTuiKanList()
    //获取地址列表数据
    this.selectSysInstance()
  },
  methods: {
    loadMore () {
      if (this.sysInstanceIndex + 1 >= this.sysInstanceTotalPages) return
      this.sysInstanceIndex++
      // 获取列表数据的方法
      this.selectSysInstance()
    },
    // 查询退货地址列表
    async  selectSysInstance () {
      let para = new URLSearchParams()
      para.append('pageIndex', this.sysInstanceIndex)
      para.append('pageSize', this.currentpageSize)
      //请求接口
      await queryListAddress(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.selectSysInstanceList = [...this.selectSysInstanceList, ...data.data.rows]
          this.sysInstanceTotalPages = data.data.total
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    onPreview () {
      console.log(11);
      this.$refs.preview.clickHandler();
    },
    //获取退款列表
    getTuiKanList () {
      let para = new URLSearchParams()
      para.append('pageIndex', this.currentpageIndex)
      para.append('pageSize', this.currentpageSize)
      para.append('status', this.status)
      queryByReturnOrderList(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.tableData = data.data.rows
          console.log(this.tableData);
          this.total = data.data.total
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    //筛选
    handleSearch (index) {
      console.log(index);
      this.status = index
      this.currentpageIndex = 1
      this.getTuiKanList()
    },
    // 提交给后台同意退款
    handleSendExpress () {
      let para = new URLSearchParams()
      para.append('id', this.ruleForm.id)
      para.append('status', 1)
      para.append('handleNote', this.ruleForm.handleNote)
      if (this.ruleForm.type === 2) {
        para.append('companyAddressId', this.ruleForm.companyAddressId)
      }
      updateReturnOrderHandle(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          //关闭弹窗
          this.sendGoodsdialogVisible = false
          this.$refs.ruleForm.resetFields()
          //查询列表
          this.getTuiKanList()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 退款
    handleTui (index, item) {
      console.log(index, item);
      if (item.type == 1) {
        //仅退款
        this.sendGoodsdialogVisible3 = true
        this.ruleFormTui.id = item.id
      } else {
        if (item.expressSn) {
          this.sendGoodsdialogVisible3 = true
          this.ruleFormTui.id = item.id
        } else {
          this.$message({
            message: "请等待用户填写退货物流之后再退款",
            type: 'error'
          })
        }
      }
    },
    //退款提交
    handleTuiKuan () {
      var that = this
      let para = new URLSearchParams()
      para.append('id', this.ruleFormTui.id)
      para.append('status', 1)
      returnMoney(para).then(data => {
        console.log(data);
        if (data.code === 20000) {
          this.sendGoodsdialogVisible3 = false
          //等待一分钟之后刷新列表
          this.$message({
            message: "退款有延迟需耐心等待70s，如果订单状态没有改变，请检查商户余额是否充足",
            type: 'success'
          })
          setInterval(function () {
            that.getTuiKanList()
          }, 70000)
        } else if (data.code === 10000) {
          //关闭弹窗
          this.sendGoodsdialogVisible3 = false
          //通知上面的点击事件按钮禁用
          this.ruleFormTui.id = ''
          //查询列表
          that.getTuiKanList()
        } else if (data.code === -30000) {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    //拒绝弹窗
    handleSendRe (index, item) {
      //弹窗显示
      this.sendGoodsdialogVisible2 = true
      this.ruleFormCr.id = item.id
    },
    handleRe () {
      //提交
      let para = new URLSearchParams()
      para.append('id', this.ruleFormCr.id)
      para.append('status', 3)
      para.append('handleNote', this.ruleFormCr.handleNote)
      updateReturnOrderHandle(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          //关闭弹窗
          this.sendGoodsdialogVisible2 = false
          this.$refs.ruleFormCr.resetFields()
          //查询列表
          this.getTuiKanList()
        }
      })

    },
    //查看
    handleDetail (index, row) {
      console.log(index, row);
      this.url = ''
      this.srcList = []
      this.detaildialogVisible = true
      this.detailData = row
      if (this.detailData.proofPics) {
        if (this.detailData.proofPics.includes(',')) {
          this.url = this.detailData.proofPics.split(',')[0]
          this.srcList = this.detailData.proofPics.split(',')
        } else {
          this.url = this.detailData.proofPics
          this.srcList.push(this.detailData.proofPics)
        }
      }
      // 有物流单号才查询
      if (this.detailData.expressSn) {
        // 先拿到手机号
        this.queryOrderDetail(this.detailData.orderId, this.detailData.expressSn)
      }

    },
    // 订单详情接口
    queryOrderDetail (orderId, deliverySn) {
      let para = new URLSearchParams()
      para.append('orderId', orderId)
      queryOrderDetails(para).then(data => {
        console.log("111", data);
        if (data.code === 10000) {
          if (data.data.receiverPhone) {
            let phone = data.data.receiverPhone + ''
            let lastPhone = phone.substr(-4)
            //查询物流公司
            this.getOrderExpressCompany(lastPhone, deliverySn)
          }
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 查询物流公司
    getOrderExpressCompany (lastPhone, deliverySn) {
   let para = new URLSearchParams()
      para.append('number', deliverySn)
      para.append('phone', lastPhone)
      queryWuLiu(para).then(data => {
        console.log(data);
        // console.log(data);
        if (data.code === 10000) {
          console.log(data);
          const wuLiuMsg = JSON.parse(data.data)
          if (wuLiuMsg.showapi_res_code === 0) {
            this.wuliuArr = wuLiuMsg.showapi_res_body.data
          } else {
            this.$message({
              message: wuLiuMsg.showapi_res_error,
              type: 'error'
            })
          }
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })

    },

    // 同意弹窗
    handleSendAg (index, item) {
      console.log(item);
      this.sendGoodsdialogVisible = true
      this.ruleForm.id = item.id
      this.ruleForm.type = item.type
    },
    handelCurrentChange (i) { // 分页
      console.log(i);
      this.currentpageIndex = i
      this.getTuiKanList()
    },
  },

}
</script>

<style lang="stylus">
#profit {
  .comond_btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;

    button {
      background-color: #0a3d5f;
      color: #fff;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>

